import { useContext } from "react";
import { FormOrchestratorContextType } from "./types";
import { FormOrchestratorContext } from "./FormOrchestrator";

/**
 * Hook to use the FormOrchestrator context
 * 
 * This hook provides access to the FormOrchestrator context, which manages
 * form state, navigation, and submission for multi-step forms.
 * 
 * @returns The FormOrchestrator context
 * @throws Error if used outside of a FormOrchestrator provider
 */
export const useFormOrchestrator = (): FormOrchestratorContextType => {
  const context = useContext(FormOrchestratorContext);
  
  if (context === undefined) {
    throw new Error("useFormOrchestrator must be used within a FormOrchestrator provider");
  }
  
  return context;
};

export default useFormOrchestrator;
